export const useCountWords = (text: string) => {
  // Count the number of words in the text
  if (text.trim().length == 0) return 0;

  const words = text.trim().split(/\s+/);
  return words.length;
};
